import { Box, Skeleton, useTheme } from '@mui/material';

export default function CalendarViewSkeleton() {
  const theme = useTheme();

  return (
    <Box sx={{ p: 3 }}>
      {/* header skeleton */}
      <Skeleton variant="text" width="200px" height={40} sx={{ mb: 2 }} />

      {/* tabs skeleton */}
      <Box sx={{ display: 'flex', mb: 3 }}>
        <Skeleton variant="rectangular" width={100} height={40} sx={{ mr: 2, borderRadius: 1 }} />
        <Skeleton variant="rectangular" width={100} height={40} sx={{ borderRadius: 1 }} />
      </Box>

      {/* calendar skeleton */}
      <Box sx={{
        height: 'calc(100vh - 200px)',
        minHeight: 500,
        bgcolor: 'background.paper',
        borderRadius: 1,
        boxShadow: theme.shadows[1],
        p: 2,
      }}>
        {/* calendar header */}
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
          <Skeleton variant="rectangular" width={150} height={36} sx={{ borderRadius: 1 }} />
          <Box sx={{ display: 'flex' }}>
            <Skeleton variant="rectangular" width={36} height={36} sx={{ borderRadius: 1, mr: 1 }} />
            <Skeleton variant="rectangular" width={36} height={36} sx={{ borderRadius: 1, mr: 1 }} />
            <Skeleton variant="rectangular" width={36} height={36} sx={{ borderRadius: 1 }} />
          </Box>
        </Box>

        {/* calendar grid */}
        <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: 1 }}>
          {Array(7).fill(0).map((_, index) => (
            <Skeleton key={`header-${index}`} variant="text" height={30} />
          ))}

          {Array(35).fill(0).map((_, index) => (
            <Skeleton
              key={`cell-${index}`}
              variant="rectangular"
              height={80}
              sx={{ borderRadius: 1 }}
            />
          ))}
        </Box>
      </Box>
    </Box>
  );
}